import { useEffect, useState } from "react";
import axios from "axios";
import { MoveHorizontal } from "lucide-react";
import { API } from "@/lib/api";
import { imgUrl } from "@/components/site/WorkGallery";

export const BeforeAfterSlider = ({ t }) => {
  const [pos, setPos] = useState(50);
  return (
    <figure data-testid={`ba-item-${t.id}`}>
      <div className="relative aspect-[4/3] select-none overflow-hidden rounded-xl bg-[#EDF0F5]">
        <img src={imgUrl(t.after_id)} alt={`${t.title} after`} loading="lazy" className="absolute inset-0 h-full w-full object-cover" draggable={false} />
        <img src={imgUrl(t.before_id)} alt={`${t.title} before`} loading="lazy" className="absolute inset-0 h-full w-full object-cover" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }} draggable={false} />
        <span className="absolute left-3 top-3 rounded-md bg-[#0E1F3F] px-2.5 py-1 text-xs font-bold uppercase text-white">Before</span>
        <span className="absolute right-3 top-3 rounded-md bg-[#F2B91C] px-2.5 py-1 text-xs font-bold uppercase text-[#0E1F3F]">After</span>
        <div className="pointer-events-none absolute inset-y-0 w-1 -translate-x-1/2 bg-white shadow" style={{ left: `${pos}%` }}>
          <span className="absolute top-1/2 left-1/2 grid h-10 w-10 -translate-x-1/2 -translate-y-1/2 place-items-center rounded-full bg-white text-[#0E1F3F] shadow-lg"><MoveHorizontal size={18} /></span>
        </div>
        <input type="range" min="0" max="100" value={pos} onChange={(e) => setPos(Number(e.target.value))} aria-label="Drag to compare before and after"
          data-testid={`ba-slider-${t.id}`} className="absolute inset-0 h-full w-full cursor-ew-resize opacity-0" />
      </div>
      {(t.title || t.caption) && (
        <figcaption className="mt-3"><p className="font-display font-semibold">{t.title}</p>{t.caption && <p className="text-sm text-[#5C5850]">{t.caption}</p>}</figcaption>
      )}
    </figure>
  );
};

export const BeforeAfter = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${API}/transformations`).then((r) => setItems(r.data)).catch(() => {});
  }, []);
  if (!items.length) return null;
  return (
    <section id="before-after" className="border-t border-[#E6E2DA] bg-white py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <p className="eyebrow mb-3">Before &amp; after</p>
        <h2 className="font-display mb-3 text-3xl font-bold tracking-tight sm:text-4xl">See the transformation.</h2>
        <p className="mb-10 text-[#5C5850]">Drag the slider on each photo to compare.</p>
        <div className="grid gap-8 md:grid-cols-2">{items.map((t) => <BeforeAfterSlider key={t.id} t={t} />)}</div>
      </div>
    </section>
  );
};
